<template>
    <div class="q-pa-md">

        <q-stepper v-model="step" header-nav ref="stepper" color="primary" animated class="no-shadow" bordered>
            <q-step :name="1" title="Información del Usuario" icon="settings" :done="done1">
                <datos-generales></datos-generales>
            </q-step>

            <q-step :name="2" title="Datos Fiscales" caption="Optional" icon="create_new_folder" :done="done2">
                <datos-fiscales></datos-fiscales>
            </q-step>

            <q-step :name="3" title="Datos Legales" icon="add_comment" :done="done3">
                <datos-legales></datos-legales>
            </q-step>

            <q-step :name="4" title="Documentos" icon="add_comment" :done="done4">
                <documentos></documentos>
            </q-step>

            <q-step :name="5" title="Domicilio" icon="add_comment" :done="done5">
                <domicilio></domicilio>
            </q-step>
        </q-stepper>
    </div>
</template>
<script>

import DatosGenerales from './DatosGenerales.vue'
import DatosFiscales from './DatosFiscales.vue'
import DatosLegales from './DatosLegales.vue'
import Documentos from './Documentos.vue'
import Domicilio from './Domicilio.vue'

export default {
    components: {
        DatosGenerales,
        DatosFiscales,
        DatosLegales,
        Documentos,
        Domicilio,
    },
    data() {
        return {
            step: 1,
            done1: false,
            done2: false,
            done3: false,
            done4: false,
            done5: false,
        }
    },

    methods: {
        reset() {
            this.done1 = false
            this.done2 = false
            this.done3 = false
            this.step = 1
        }
    }
}
</script>